export default __webpack_public_path__ + "images/banner-guy.669ddd50e53d8d90759cc597d8e97570.png";